var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('tux-profile-confirmation',{attrs:{"cta-label":_vm.$t('button.profileSignIn')},on:{"cta-click":_vm.route,"merchant-click":_vm.logAnalytics}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }